import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { useNavContextValue } from "#nav-context-value";

export type NavContextValue = ReturnType<typeof useNavContextValue>;

export const NavContext = createContext(defaultError<NavContextValue>("NavContext"));
